import { Button } from "@mui/material";
import axios from "axios";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function Event() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const [expanded, setExpanded] = useState({});

  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  // const getNews = () => {
  //   axios
  //     .post(
  //       "https://m1blog.aaragroups.com/blog/api/admin/api/event_list_api/",
  //       {},
  //       {
  //         headers: {
  //           token: localStorage.getItem("token"),
  //           "Access-Control-Allow-Origin": "*",
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       setData(res.data?.news_details);
  //     })
  //     .catch((err) => {
  //       toast.error(err?.response?.data?.message);
  //     });
  // };

  const getNews = () => {
    axios
      .get(
        "https://m1blog.aaragroups.com/blog/api/admin/api/event_list_api/",
        // {},
        {
          params: {},
          headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*",
          },
        },
      )
      .then((res) => {
        setData(res.data?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const deleteNews = (id) => {
    axios
      .delete(
        `https://m1blog.aaragroups.com/blog/api/admin/api/event_deatils_api/?id=${id}`,

        {
          headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*",
          },
        },
      )
      .then((res) => {
        getNews();
        toast.success(res?.data?.message);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    getNews();
  }, []);

  return (
    <>
      {/* Heading */}
      <h1 className="my-6 sm:my-0 text-4xl font-extrabold text-center text-blue-900 tracking-wide">
        Events
      </h1>

      {/* Add Event Button */}
      <div className="flex justify-end mb-">
        <NavLink to="/addevent">
          <Button
            variant="outlined"
            className="!font-semibold !text-gray-700 !border-blue-600 hover:!bg-blue-50"
          >
            + Add Event
          </Button>
        </NavLink>
      </div>

      {/* Events Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {data?.map((item) => {
          const isExpanded = expanded[item.id];
          const shortContent =
            item.Content?.length > 120
              ? item.Content.substring(0, 120) + "..."
              : item.Content;

          return (
            <div
              key={item.id}
              className="group bg-white rounded-2xl shadow-md hover:shadow-xl border border-gray-200 transition-all duration-300 flex flex-col overflow-hidden"
            >
              {/* Image */}
              <div className="relative">
                <img
                  src={
                    item.images
                      ? `${item.images}?${Date.now()}`
                      : "/fallback.png"
                  }
                  alt="event"
                  className="h-48 w-full object-cover group-hover:scale-105 transition-transform duration-300"
                />

                <div className="absolute  top-3 right-3 flex gap-2  items-center">
                  <span className="  bg-blue-600 text-white text-xs font-medium px-3 py-1 rounded-full shadow">
                    {moment(item?.start_date || "").format("DD-MM-YYYY")}
                  </span>
                  <span className="  bg-blue-600 text-white text-xs font-medium px-3 py-1 rounded-full shadow">
                    To
                  </span>
                  <span className="  bg-blue-600 text-white text-xs font-medium px-3 py-1 rounded-full shadow">
                    {moment(item?.end_date || "").format("DD-MM-YYYY")}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-lg font-bold text-gray-800 mb-2 line-clamp-1">
                  {item.Title}
                </h3>

                <div className="text-gray-600 text-sm leading-relaxed mb-2">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: isExpanded ? item.Content : shortContent,
                    }}
                  ></div>

                  {item.Content?.length > 120 && (
                    <button
                      onClick={() => toggleExpand(item.id)}
                      className="mt-2 text-blue-600 font-medium hover:underline"
                    >
                      {isExpanded ? "Show Less" : "Show More"}
                    </button>
                  )}
                </div>

                {/* Actions */}
                <div className="mt-auto flex justify-between gap-4">
                  <Button
                    onClick={() => navigate(`/eventupdate/${item.id}`)}
                    variant="outlined"
                    className="!border-blue-600 !text-blue-600 hover:!bg-blue-50 flex-1"
                  >
                    Update
                  </Button>
                  <Button
                    onClick={() => deleteNews(item.id)}
                    variant="outlined"
                    className="!border-red-500 !text-red-500 hover:!bg-red-50 flex-1"
                  >
                    Delete
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
